export default __webpack_public_path__ + "static/media/yeti.e204fb65.png";